import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { getSettingRetailerAvailableLocales } from "@faire/retailer-visitor-shared/settings/getSettingRetailerAvailableLocales";
import { DEFAULT_LOCALE_KEY } from "@faire/web--source/common/consts/DEFAULT_LOCALE";
import { THREE_TO_FULL_LANGUAGE_NAME } from "@faire/web--source/common/consts/THREE_TO_FULL_LANGUAGE_NAME";
import { THREE_TO_TWO_LETTER_LANGUAGE_CODE } from "@faire/web--source/common/consts/THREE_TO_TWO_LETTER_LANGUAGE_CODE";
import { TWO_TO_THREE_LETTER_COUNTRY_ISO_CODE } from "@faire/web--source/common/consts/TWO_TO_THREE_LETTER_COUNTRY_ISO_CODE";
import { getNavigator } from "@faire/web--source/common/globals/getNavigator";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { isLanguageDuplicatedInLocales } from "@faire/web--source/common/localization/languageOptions";
import { localeKeyToFullLanguageName } from "@faire/web--source/common/localization/localeKeyToFullLanguageName";
import { localeKeyToLocaleString } from "@faire/web--source/common/localization/localeKeyToLocaleString";
import { logError } from "@faire/web--source/common/logging";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { ILocaleKey } from "@faire/web-api--source/indigofair/locale/ILocaleKey";
import find from "lodash/find";
import invert from "lodash/invert";
var getLocaleKeyLabel = function(localeKey) {
    if (localeKey.language === undefined) {
        logError(new Error("Cannot get label of undefined language"));
        return "";
    }
    return isLanguageDuplicatedInLocales(Language[localeKey.language], getSettingRetailerAvailableLocales()) ? localeKeyToFullLanguageName(localeKey) : THREE_TO_FULL_LANGUAGE_NAME[localeKey.language];
};
export var communicationLocaleKeysOptions = function() {
    return getSettingRetailerAvailableLocales().map(function(localeKey) {
        return {
            label: getLocaleKeyLabel(localeKey),
            value: localeKeyToLocaleString({
                localeKey: localeKey,
                dashFormat: false
            })
        };
    });
};
var TWO_TO_THREE_LETTER_LANGUAGE_CODE = invert(THREE_TO_TWO_LETTER_LANGUAGE_CODE);
export var getBrowserDefaultLanguage = function() {
    var _getWindow_navigator_language, _getWindow_navigator, _getWindow;
    var _getWindow_navigator_language_toUpperCase;
    var defaultLanguage = (_getWindow_navigator_language_toUpperCase = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_navigator = _getWindow.navigator) === null || _getWindow_navigator === void 0 ? void 0 : (_getWindow_navigator_language = _getWindow_navigator.language) === null || _getWindow_navigator_language === void 0 ? void 0 : _getWindow_navigator_language.toUpperCase()) !== null && _getWindow_navigator_language_toUpperCase !== void 0 ? _getWindow_navigator_language_toUpperCase : "";
    if (defaultLanguage.includes("-")) {
        var _defaultLanguage_split_;
        defaultLanguage = (_defaultLanguage_split_ = defaultLanguage.split("-")[0]) !== null && _defaultLanguage_split_ !== void 0 ? _defaultLanguage_split_ : "";
    }
    return TWO_TO_THREE_LETTER_LANGUAGE_CODE[defaultLanguage];
};
/**
 * Attempts to parse the string to ILocaleKey. Assumes the string is in standard
 * locale format, e.g. "fr", "fr-FR", or "fr_FR".
 * @param locale the locale string in standard locale format
 * @returns the locale key or DEFAULT_LOCALE_KEY if parsing was not successful
 * @deprecated use localeStringToLocaleKey in @faire/web/common instead
 */ export var getLocaleKeyFromLocaleString = function(locale) {
    var defaultLanguage = locale.toUpperCase();
    var defaultCountry, splittedDefaultLanguage, splittedDefaultCountry;
    if (defaultLanguage.includes("-")) {
        var ref;
        ref = _sliced_to_array(defaultLanguage.split("-"), 2), splittedDefaultLanguage = ref[0], splittedDefaultCountry = ref[1], ref;
    } else if (defaultLanguage.includes("_")) {
        var ref1;
        ref1 = _sliced_to_array(defaultLanguage.split("_"), 2), splittedDefaultLanguage = ref1[0], splittedDefaultCountry = ref1[1], ref1;
    }
    if (splittedDefaultCountry) {
        defaultCountry = splittedDefaultCountry;
    }
    if (splittedDefaultLanguage) {
        defaultLanguage = splittedDefaultLanguage;
    }
    var threeLetterLanguage = TWO_TO_THREE_LETTER_LANGUAGE_CODE[defaultLanguage];
    var language = threeLetterLanguage ? Language[threeLetterLanguage] : Language.ENG;
    var country = defaultCountry ? ISO3166Alpha3[TWO_TO_THREE_LETTER_COUNTRY_ISO_CODE[defaultCountry]] : undefined;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = getSettingRetailerAvailableLocales()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var localeKey = _step.value;
            if (localeKey.language === language && localeKey.country === country) {
                // the locale matches a supported locale
                return _object_spread({}, localeKey);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (language in Language) {
        return {
            language: language,
            country: undefined
        };
    }
    return DEFAULT_LOCALE_KEY;
};
/**
 * Returns the locale key associated with the browser's default language.
 * This assumes the browser returns its language in on of the standard format, i.e.
 * "fr", "fr-FR", or "fr_FR".
 * @returns the ILocaleKey representation of the browser locale, or DEFAULT_LOCALE_KEY
 *  if it cannot determine the correct form
 */ export var getBrowserDefaultLocaleKey = function() {
    var _getNavigator;
    var _getNavigator_language;
    return getLocaleKeyFromLocaleString((_getNavigator_language = (_getNavigator = getNavigator()) === null || _getNavigator === void 0 ? void 0 : _getNavigator.language) !== null && _getNavigator_language !== void 0 ? _getNavigator_language : "");
};
/**
 * If the locale key passed in does not exist in RETAILER_AVAILABLE_LOCALES setting,
 * this returns the first supported locale key with matching language, otherwise it
 * returns the matching available locale key.
 *
 * e.g. localeKey={ language: "ITA" } -> returns { language: "ITA", country: "ITA" }
 *
 * @param localeKey the locale key to infer country for
 * @returns locale key with matching language from retailer available locales, else DEFAULT_LOCALE_KEY
 */ export var getLocaleKeyWithInferredCountry = function(localeKey) {
    var matchingLocaleInAvailableLocales = find(getSettingRetailerAvailableLocales(), ILocaleKey.build({
        language: localeKey.language,
        country: localeKey.country
    }));
    if (matchingLocaleInAvailableLocales) {
        return matchingLocaleInAvailableLocales;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = getSettingRetailerAvailableLocales()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var availableLocale = _step.value;
            if (availableLocale.language === localeKey.language) {
                return availableLocale;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return DEFAULT_LOCALE_KEY;
};
